import { takeLatest, all } from 'redux-saga/effects';

import {
  getCheckoutDetailsData,
  validateEmailApi,
  verifyEmailApi,
  verifyMobileApi,
  addRemoveAccessory,
  addRemoveYtTvAddon,
  IsPromoCodeValid,
  // contactInfoErrors,
} from './checkout.sagaHelpers';
import * as actionTypes from './actionTypes';

function* actionWatcher() {
  yield takeLatest(actionTypes.GET_EXPRESS_CHECKOUT_DETAILS, getCheckoutDetailsData);

  yield takeLatest(actionTypes.VERIFY_EMAIL_API, verifyEmailApi);
  yield takeLatest(actionTypes.VALIDATE_EMAIL, validateEmailApi);
  yield takeLatest(actionTypes.VALIDATE_MOBILE, verifyMobileApi);
  yield takeLatest(actionTypes.EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY, addRemoveAccessory);
  yield takeLatest(actionTypes.EXPRESS_CHECKOUT_ADD_REMOVE_YTTV, addRemoveYtTvAddon);
  yield takeLatest(actionTypes.EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE, IsPromoCodeValid);
  // yield takeLatest(actionTypes.CONTACT_INFO_ERRORS, contactInfoErrors);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
